import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
    selector: 'header-menu',
    templateUrl: 'header.component.html'
})
export class HeaderComponent {

}